import { ApiService } from '@agent-ds/shared/models/api-service';
import { toAsialRequestParameters } from '@agent-ds/shared/util/util';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CustomerApiService extends ApiService {
    constructor(http) {
        super();
        this.http = http;
    }
    getList(search) {
        return this.http.get('/api/customer/search', { params: search });
    }
    getTeamCustomerList(teamId, params) {
        return this.http.get(`/api/customer/searchTeamCustomer/${teamId}`, { params: params });
    }
    getMySalesTargetCustomerListOfExpectedContractMonth(targetDateString, search) {
        const startOfTargetMonthDateFormattedString = moment(targetDateString)
            .startOf('month') // 月初に設定
            .format('YYYY-MM-DD');
        const endOfTargetMonthDateFormattedString = moment(targetDateString)
            .endOf('month') // 月末に設定
            .format('YYYY-MM-DD');
        const searchQuery = Object.assign({}, search, { expectedContractOrDeclinedDateFrom: startOfTargetMonthDateFormattedString, expectedContractOrDeclinedDateTo: endOfTargetMonthDateFormattedString });
        return this.http.get('/api/customer/searchMySalesTarget', { params: searchQuery });
    }
    getTeamSalesTargetCustomerListOfExpectedContractMonth(teamId, targetDateString, search) {
        const startOfTargetMonthDateFormattedString = moment(targetDateString)
            .startOf('month') // 月初に設定
            .format('YYYY-MM-DD');
        const endOfTargetMonthDateFormattedString = moment(targetDateString)
            .endOf('month') // 月末に設定
            .format('YYYY-MM-DD');
        const searchQuery = Object.assign({}, search, { expectedContractOrDeclinedDateFrom: startOfTargetMonthDateFormattedString, expectedContractOrDeclinedDateTo: endOfTargetMonthDateFormattedString });
        return this.http.get(`/api/customer/searchTeamSalesTarget/${teamId}`, { params: searchQuery });
    }
    getMyRaSalesTargetCustomerListOfExpectedContractMonth(targetDateString, search) {
        const startOfTargetMonthDateFormattedString = moment(targetDateString)
            .startOf('month') // 月初に設定
            .format('YYYY-MM-DD');
        const endOfTargetMonthDateFormattedString = moment(targetDateString)
            .endOf('month') // 月末に設定
            .format('YYYY-MM-DD');
        const searchQuery = Object.assign({}, search, { expectedContractOrDeclinedDateFrom: startOfTargetMonthDateFormattedString, expectedContractOrDeclinedDateTo: endOfTargetMonthDateFormattedString });
        return this.http.get('/api/customer/searchMyRaSalesTarget', { params: searchQuery });
    }
    getMyRaSalesTargetCustomerTotalOfExpectedContractMonth(targetDateString, search) {
        const startOfTargetMonthDateFormattedString = moment(targetDateString)
            .startOf('month')
            .format('YYYY-MM-DD');
        const endOfTargetMonthDateFormattedString = moment(targetDateString)
            .endOf('month')
            .format('YYYY-MM-DD');
        const searchQuery = Object.assign({}, search, { expectedContractOrDeclinedDateFrom: startOfTargetMonthDateFormattedString, expectedContractOrDeclinedDateTo: endOfTargetMonthDateFormattedString });
        return this.http.get('/api/customer/searchMyRaSalesTargetTotal', { params: searchQuery });
    }
    getTeamRaSalesTargetCustomerListOfExpectedContractMonth(teamId, targetDateString, search) {
        const startOfTargetMonthDateFormattedString = moment(targetDateString)
            .startOf('month') // 月初に設定
            .format('YYYY-MM-DD');
        const endOfTargetMonthDateFormattedString = moment(targetDateString)
            .endOf('month') // 月末に設定
            .format('YYYY-MM-DD');
        const searchQuery = Object.assign({}, search, { expectedContractOrDeclinedDateFrom: startOfTargetMonthDateFormattedString, expectedContractOrDeclinedDateTo: endOfTargetMonthDateFormattedString });
        return this.http.get(`/api/customer/searchTeamRaSalesTarget/${teamId}`, { params: searchQuery });
    }
    getTeamRaSalesTargetCustomerTotalOfExpectedContractMonth(teamId, targetDateString, search) {
        const startOfTargetMonthDateFormattedString = moment(targetDateString)
            .startOf('month')
            .format('YYYY-MM-DD');
        const endOfTargetMonthDateFormattedString = moment(targetDateString)
            .endOf('month')
            .format('YYYY-MM-DD');
        const searchQuery = Object.assign({}, search, { expectedContractOrDeclinedDateFrom: startOfTargetMonthDateFormattedString, expectedContractOrDeclinedDateTo: endOfTargetMonthDateFormattedString });
        return this.http.get(`/api/customer/searchTeamRaSalesTargetTotal/${teamId}`, { params: searchQuery });
    }
    getDetail(id) {
        return this.http.get('/api/customers/' + id).pipe(tap((student) => {
            student.userId = student.studentUsers && student.studentUsers.length ? student.studentUsers[0].userId : null;
            // 副担当者のIDを抽出
            if (student.studentSubUsers && student.studentSubUsers.length) {
                student.subUserIds = student.studentSubUsers.map((studentSubUser) => {
                    return studentSubUser.userId;
                });
            }
            else {
                // do nothing
            }
            return student;
        }));
    }
    calcYomi3Probability(search) {
        return this.http.get(`/api/customer/progress/calcYomi3Probability`, { params: search });
    }
    /*
    後々拡張の可能性あり
    updateMemo(id: number, memo: SituationMemo): Observable<any> {
      return this.http.put(`/api/customers/${id}/memos/${memo.id}`, memo);
    }
  
    updateNote(studentId: number, note: StudentNote): Observable<any> {
      return this.http.put(`/api/customers/${studentId}/note/${note.id}`, note);
    }
    */
    updateExpectedSK(studentId, progressId, expectedSk) {
        return this.http.put(`/api/customer/progress/expectedSk`, { studentId, progressId, expectedSk });
    }
    updateExpectedCompanyFlag(studentId, currentProgressId, updateProgressId) {
        return this.http.put(`/api/customer/expected/${studentId}/${currentProgressId}/${updateProgressId}`, {});
    }
    updateExpectedCompany2Flag(studentId, currentProgressId, updateProgressId) {
        return this.http.put(`/api/customer/expectedCompany2/${studentId}/${currentProgressId}/${updateProgressId}`, {});
    }
    updateExpectedContractMonth(studentId, expectedContractMonth) {
        return this.http.put(`/api/customer/expectedContractMonth/${studentId}`, { expectedContractMonth });
    }
    updateExpectedContractWeek(studentId, expectedContractWeek) {
        return this.http.put(`/api/customer/expectedContractWeek/${studentId}`, { expectedContractWeek });
    }
    updateRaExpectedContractMonth(progressId, expectedContractMonth) {
        return this.http.put(`/api/customer/progress/${progressId}/raExpectedContractMonth`, { progressId, expectedContractMonth });
    }
    updateRaExpectedContractWeek(progressId, expectedContractWeek) {
        return this.http.put(`/api/customer/progress/${progressId}/raExpectedContractWeek`, { progressId, expectedContractWeek });
    }
    updateYomi(id, request) {
        return this.http.put(`/api/customer/${id}/yomi`, request);
    }
    updateRaYomi(progressId, request) {
        return this.http.put(`/api/customer/progress/${progressId}/raYomi`, request);
    }
    updateYomi3Passed(request) {
        return this.http.put(`/api/customer/progress/${request.progressId}/yomi3Passed`, request);
    }
    updateYomi3Inclination(request) {
        return this.http.put(`/api/customer/progress/${request.progressId}/yomi3Inclination`, request);
    }
    updateYomi3Schedule(request) {
        return this.http.put(`/api/customer/progress/${request.progressId}/yomi3Schedule`, request);
    }
    updateRaYomi3Passed(request) {
        return this.http.put(`/api/customer/progress/${request.progressId}/raYomi3Passed`, request);
    }
    updateRaYomi3Inclination(request) {
        return this.http.put(`/api/customer/progress/${request.progressId}/raYomi3Inclination`, request);
    }
    updateRaYomi3Schedule(request) {
        return this.http.put(`/api/customer/progress/${request.progressId}/raYomi3Schedule`, request);
    }
    updateRaMemo(request) {
        return this.http.put(`/api/customer/progress/${request.progressId}/raMemo`, request);
    }
    getSalesReportOfCurrentUser(query) {
        const params = query ? toAsialRequestParameters(query) : {};
        return this.http.get(`/api/customer/sales/amountOfCurrentUser`, { params: params });
    }
    getSalesReport(query) {
        const params = query ? toAsialRequestParameters(query) : undefined;
        return this.http.get(`/api/customer/sales/amount`, { params: (params ? params : {}) });
    }
    getTeamMonthlySalesOverviews(teamId, year, month, query) {
        const params = query ? toAsialRequestParameters(query) : {};
        params.teamId = [teamId];
        return this.http.get(`/api/customer/sales/monthlySalesOverview/${year}/${month}`, { params: params });
    }
    getMyMonthlySalesOverview(year, month, query) {
        const params = query ? toAsialRequestParameters(query) : {};
        return this.http.get(`/api/customer/sales/monthlySalesOverviewOfCurrentUser/${year}/${month}`, { params: params });
    }
    updateMyMonthlySalesOverview(year, month, input) {
        return this.http.put(`/api/customer/sales/monthlySalesOverviewOfCurrentUser/${year}/${month}`, input);
    }
}
CustomerApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerApiService_Factory() { return new CustomerApiService(i0.ɵɵinject(i1.HttpClient)); }, token: CustomerApiService, providedIn: "root" });
